import React, { useEffect, useState } from 'react';
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";
import Topbar from "./Topbar";
import { getDatabase, ref, update } from 'firebase/database';
import {
    Avatar,
    TextField,
    Pagination,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Stack
} from "@mui/material";

const Projects = () => {
    const [projects, setProjects] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage] = useState(5);
    const [selectedUser, setSelectedUser] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);

    const fetchProjects = async () => {
        try {
            const apiKey = 'your-api-key';
            const databaseURL = 'https://engenheirossemfronteiros-default-rtdb.europe-west1.firebasedatabase.app/';
            const endpoint = `Projects.json?apiKey=${apiKey}`;

            const response = await fetch(`${databaseURL}/${endpoint}`);

            if (!response.ok) {
                throw new Error(`Error fetching project list: ${response.statusText}`);
            }

            const projectsData = await response.json();

            if (!projectsData) {
                console.error('No projects found.');
                return;
            }

            const projectsList = Object.entries(projectsData).map(([uid, projectsData]) => ({ uid, ...projectsData }));

            const sortedProjects = projectsList.sort((a, b) => (a.Enabled === b.Enabled ? 0 : a.Enabled ? 1 : -1));
            setProjects(sortedProjects);
        } catch (error) {
            console.error('Error fetching projects:', error.message);
        }
    };

    useEffect(() => {
        fetchProjects();
    }, []);

    const deleteProject = async (projectID) => {
        try {
            const apiKey = 'your-api-key';
            const databaseURL = 'https://engenheirossemfronteiros-default-rtdb.europe-west1.firebasedatabase.app/';
            const endpoint = `Projects/${projectID}.json?apiKey=${apiKey}`;

            const response = await fetch(`${databaseURL}/${endpoint}`, {
                method: 'DELETE',
            });

            if (!response.ok) {
                throw new Error(`Erro ao apagar projeto: ${response.statusText}`);
            }

            console.log(`Projeto com UID ${projectID} apagado com sucesso.`);
            await fetchProjects();
        } catch (error) {
            console.error('Erro ao apagar o projeto:', error.message);
        }
    };

    async function updateEnabledParameter(projectID, newEnabledValue) {
        const db = getDatabase();
        const updates = {};
        updates['/Projects/' + projectID + '/Enabled'] = newEnabledValue;

        try {
            await update(ref(db), updates);
            setProjects((prevProjects) =>
                prevProjects.map((project) =>
                    project.uid === projectID ? { ...project, Enabled: newEnabledValue } : project
                )
            );
            console.log('Enabled parameter updated successfully');
        } catch (error) {
            console.error('Error updating enabled parameter:', error.message);
        }
    }

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value.toLowerCase());
        setCurrentPage(1);
    };

    const filteredProjects = projects.filter(project =>
        project.Title?.toLowerCase().includes(searchQuery) ||
        project.Association?.toLowerCase().includes(searchQuery) ||
        project.College?.toLowerCase().includes(searchQuery) ||
        project.Location?.toLowerCase().includes(searchQuery) ||
        project.Time?.toLowerCase().includes(searchQuery) ||
        project.Type?.toLowerCase().includes(searchQuery)
    );

    const totalPages = Math.ceil(filteredProjects.length / usersPerPage);
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = filteredProjects.slice(indexOfFirstUser, indexOfLastUser);

    const handleChangePage = (event, newPage) => {
        setCurrentPage(newPage);
    };

    const handleOpenDialog = (user) => {
        setSelectedUser(user);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Topbar />
            <TextField
                fullWidth
                label="Pesquisar"
                variant="outlined"
                sx={{ margin: "8px", width: 'calc(100% - 16px)' }}
                onChange={handleSearchChange}
            />
            <Paper elevation={3} sx={{ margin: "0 8px" }}>
                <TableContainer component={Paper} sx={{ mt: 4, overflow: 'hidden', borderRadius: '12px', boxShadow: '0px 4px 12px rgba(0,0,0,0.1)' }}>
                    <Table sx={{ minWidth: 650 }} aria-label="project table">
                        <TableHead sx={{ backgroundColor: '#1C4E80' }}>
                            <TableRow>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}> </TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Título</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Associação</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Colégio</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Localização</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Tempo</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Tipo</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: 'bold' }} align="right">Estado</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {currentUsers.map((project) => (
                                <TableRow
                                    key={project.uid}
                                    onClick={() => handleOpenDialog(project)}
                                    style={{ cursor: 'pointer' }}
                                    sx={{ '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' } }}
                                >
                                    <TableCell><Avatar alt={project.Id} src={project.Logo} /></TableCell>
                                    <TableCell>{project.Title || 'N/A'}</TableCell>
                                    <TableCell>{project.Association || 'N/A'}</TableCell>
                                    <TableCell>{project.College || 'N/A'}</TableCell>
                                    <TableCell>{project.Location || 'N/A'}</TableCell>
                                    <TableCell>{project.Time || 'N/A'}</TableCell>
                                    <TableCell>{project.Type || 'N/A'}</TableCell>
                                    <TableCell align="right">
                                        <Stack direction="row" spacing={1} justifyContent="flex-end">
                                            {!project.Enabled && (
                                                <Button
                                                    variant="outlined"
                                                    color="error"
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        deleteProject(project.uid);
                                                    }}
                                                >
                                                    Apagar
                                                </Button>
                                            )}
                                            <Button
                                                variant={project.Enabled ? 'contained' : 'outlined'}
                                                color={project.Enabled ? 'success' : 'error'}
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    updateEnabledParameter(project.uid, !project.Enabled);
                                                }}
                                            >
                                                {project.Enabled ? 'Ativo' : 'Ativar'}
                                            </Button>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Pagination count={totalPages} page={currentPage} onChange={handleChangePage} sx={{ '.MuiPaginationItem-root': { borderRadius: '4px' } }} />
                </Box>
            </Paper>
            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle>Detalhes</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
                        <Avatar
                            alt={selectedUser?.Id || 'N/A'}
                            src={selectedUser?.Logo || 'N/A'}
                            sx={{ width: 100, height: 100, mb: 2 }}
                        />
                        <DialogContentText sx={{ textAlign: 'left', width: '100%', mt: 2 }}>
                            <strong>Título:</strong> {selectedUser?.Title}<br /><br />
                            <strong>Associação:</strong> {selectedUser?.Association}<br /><br />
                            <strong>Colégio:</strong> {selectedUser?.College}<br /><br />
                            <strong>Localização:</strong> {selectedUser?.Location}<br /><br />
                            <strong>Tempo:</strong> {selectedUser?.Time}<br /><br />
                            <strong>Tipo:</strong> {selectedUser?.Type}<br /><br />
                            <strong>Descrição:</strong><br />
                            <span style={{ whiteSpace: 'pre-wrap' }}>{selectedUser?.Disc}</span>
                        </DialogContentText>

                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Fechar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default Projects;
